// Utilities
import { createSimpleFunctional } from '@/util'

export const VAlertTitle = createSimpleFunctional('v-alert-title')
